<template>
  <!-- 物资出库表 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="日期">
          <el-date-picker :editable="false" v-model="filteForm.dayStr" type="date" value-format="yyyy-MM-dd"
            placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="申请人">
          <el-input v-model.trim="filteForm.applicants" auto-complete="off" placeholder=""
            style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="部门">
          <el-input v-model.trim="filteForm.depart" auto-complete="off" placeholder="" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
          <el-button type="warning" icon="el-icon-plus" plain @click="handleAdd">新增出库单</el-button>
          <el-button
              type="info"
              @click="exportTable"
              icon="el-icon-download"
              plain>导出</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table :data="tableData" style="width: 100%" class="eltable" :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" :key="item2.storageId" v-for="item2 in props.row.stroageItemList">
                <el-row v-if="item2.name != null">
                  <el-col :span="4" class="rowtab">
                    <el-form-item label="商品名称:">
                      <span>{{ item2.name }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" class="rowtab">
                    <el-form-item label="商品类型:">
                      <span>{{ item2.type }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" class="rowtab">
                    <el-form-item label="数量:">
                      <span>{{ item2.number }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" class="rowtab">
                    <el-form-item label="单位:">
                      <span>{{ item2.unit }}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" class="rowtab">
                    <el-form-item label="规格:">
                      <span>{{ item2.norms }}</span>
                    </el-form-item>
                  </el-col>

                </el-row>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="no" label="编号" width="100" align=center></el-table-column>
          <el-table-column prop="type" label="出库类型" :formatter="formatType" width="100" align=center></el-table-column>
          <el-table-column prop="affirmant" label="提交人" align=center></el-table-column>
          <el-table-column prop="inTime" label="提交时间" align=center></el-table-column>
          <el-table-column prop="creator" label="确认人" align=center></el-table-column>
          <el-table-column prop="enterTime" label="确认时间" align=center></el-table-column>
          <el-table-column prop="remark" label="备注" align=center></el-table-column>
          <el-table-column label="操作" width="140" align=center>
            <template slot-scope="scope">
              <img src="@/assets/beadhouse/xiugai_icon_1.png" alt="" class="imgSize"
                @click="editProject(scope.$index, scope.row)">
              <img src="@/assets/beadhouse/shanchu_icon.png" alt="" class="imgSize"
                @click="deleteProject(scope.$index, scope.row)">
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="pageNum"
          layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize" align="center"
          class="fenye"></el-pagination>
      </div>

      <!--新增和 编辑 套餐界面-->
      <el-dialog class="packagedialog" title="添加出库表" :visible.sync="addFormVisible" width="850px"
        :close-on-click-modal="false">
        <el-form :model="addForm" :rules="addFormRules" label-width="100px" class="dialog_form" ref="addOutForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="出库单号:" prop="no">
                <el-input size="small" v-model.trim="addForm.no" :maxlength="10" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库类型:" prop="type">
                <el-select v-model="addForm.type" size="small">
                  <el-option v-for="item in typeList" :key="item.type" :label="item.name" :value="item.type">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库人员:" prop="creator">
                <el-input size="small" v-model.trim="addForm.creator" :maxlength="10" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库时间:" prop="inTime">
                <el-date-picker v-model="addForm.inTime" type="date" size="small" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="确认人员:" prop="affirmant">
                <el-input size="small" v-model.trim="addForm.affirmant" :maxlength="10" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="确认时间:" prop="enterTime">
                <el-date-picker v-model="addForm.enterTime" type="date" value-format="yyyy-MM-dd" size="small"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申领部门:" prop="depart">
                <el-input size="small" v-model.trim="addForm.depart" :maxlength="10" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注:" prop="remark">
                <el-input size="small" type="textarea" :rows="1" class="big-input" v-model.trim="addForm.remark"
                  :maxlength="200" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="tree-row">
            <el-tree class="packagemanagement-tree" :data="treeData" show-checkbox node-key="id" highlight-current
              ref="tree" :default-expand-all="false" :expand-on-click-node="false" @node-click="handleNodeClick"
              @check="checkClick" :props="defaultProps">
              <span class="custom-tree-node" slot-scope="{ node,data }">
                <span class="custom-tree-node-1">{{ node.label }}</span>
                <span class="custom-tree-node-1">{{ data.unit }} {{ data.norms }}</span>
                <span v-show="data.shopPrice != null" class="custom-tree-node-2">￥{{ data.shopPrice }}</span>
                <span v-show="data.list == null" class="custom-tree-node-2"> {{ data.number }}</span>
                <el-input-number v-if="(data.list == null)" style="width: 140px" size="mini"
                  @change="checkClick(data)" v-model="data.checkNum" :min="0" :max="data.number"></el-input-number>
              </span>
            </el-tree>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center; margin-top: 10px">
          <el-button @click.native="addFormVisible = false" style="display: inline">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addFormLoading"
            style="display: inline">确定</el-button>
        </div>
      </el-dialog>



      <!--新增和 编辑 套餐界面-->
      <el-dialog class="packagedialog" title="修改出库表" :visible.sync="editFormVisible" width="850px"
        :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" class="dialog_form" ref="addOutForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="出库单号:" prop="no">
                <el-input size="small" v-model.trim="editForm.no" :maxlength="10" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库类型:" prop="type">
                <el-select v-model="editForm.type" size="small">
                  <el-option v-for="item in typeList" :key="item.type" :label="item.name" :value="item.type">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库人员:" prop="creator">
                <el-input size="small" v-model.trim="editForm.creator" :maxlength="10" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出库时间:" prop="inTime">
                <el-date-picker v-model="editForm.inTime" type="date" size="small" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="确认人员:" prop="affirmant">
                <el-input size="small" v-model.trim="editForm.affirmant" :maxlength="10" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="确认时间:" prop="enterTime">
                <el-date-picker v-model="editForm.enterTime" type="date" value-format="yyyy-MM-dd" size="small"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申领部门:" prop="depart">
                <el-input size="small" v-model.trim="editForm.depart" :maxlength="10" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注:" prop="remark">
                <el-input size="small" type="textarea" :rows="1" class="big-input" v-model.trim="editForm.remark"
                  :maxlength="200" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center; margin-top: 10px">
          <el-button @click.native="editFormVisible = false" style="display: inline">取消</el-button>
          <el-button type="primary" @click.native="editFormSubmit" :loading="addFormLoading"
            style="display: inline">确定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0,
      loading: true,
      min: 0,
      max: 999,
      filteForm: {
        dayStr: "",
        applicants: "",
        depart: ""
      },
      typeList: [
        {
          name: "采购退库",
          type: 0,
        }, {
          name: "销售出库",
          type: 1,
        }, {
          name: "调整出库",
          type: 2,
        }, {
          name: "报损出库",
          type: 3,
        }, {
          name: "部门领用",
          type: 4,
        }, {
          name: "库房盘亏",
          type: 5,
        }, {
          name: "调拨出库",
          type: 6,
        }, {
          name: "机构调拨出库",
          type: 7,
        }
      ],
      tableData: [],
      addFormLoading: false,
      addFormVisible: false,
      addForm: {},
      editFormVisible: false,
      editForm: {},
      addFormRules: {
        no: [
          { required: true, message: "请输入单号", trigger: "blur" },
          { min: 1, max: 20, message: "长度在 1到 20 位的字符" }
        ], //by guo 2019-11-26-13:04修改
        type: [{ required: true, message: "请选择入库类型", trigger: "change" }],
        inTime: [{ required: true, message: "请选择入库时间", trigger: "blur" }],
      },
      //套餐树
      treeData: [],
      //套餐树默认显示的
      defaultProps: {
        children: "list",
        label: "label",
      },
    };
  },
  methods: {
    //点击查询
    onSubmit() {
      this.pageNum = 1;
      this.getTableData();
    },
    exportTable() {
        window.location.href =
          baseURL +
          `mdc/api/downStorageOutTable?groupId=${window.sessionStorage.getItem("groupId")}`;
      },
    formatType(row) {
      let typeStr = "";
      this.typeList.forEach(item => {
        if (row.type == item.type) {
          typeStr = item.name;
        }
      })
      return typeStr;
    },
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let params = {
        groupId: this.groupId,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        dayStr: this.filteForm.dayStr,
        depart: this.filteForm.depart,
        applicants: this.filteForm.applicants
      };
      this.loading = true;
      this.$postJson('mdc/storage/queryOutTableItemWithPage', params).then(res => {
        if (res.code == 200) {
          this.totalDataNumber = Number(res.result.total)
          this.tableData = res.result.list;
        }
        this.loading = false;
      })
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableData();
    },
    editProject(index, row) {
      this.editForm = Object.assign({}, row); //深拷贝记录
      this.editFormVisible = true;
    },
    editFormSubmit() {
      let params = {
        id: this.editForm.id,
        no: this.editForm.no,
        type: this.editForm.type,
        applicants: this.editForm.creator,
        totalPrice: this.editForm.totalPrice,
        affirmant: this.editForm.affirmant,
        remark: this.editForm.remark,
        depart: this.editForm.depart,
        creator: this.editForm.creator,
        groupId: this.editForm.groupId,
      }
      console.log(params);
      this.$postJson('mdc/storage/editOutTable', params).then(res => {
        if (res.code = 200) {
          this.getTableData();
          this.getPjStock();
          this.editFormVisible = false;
        }
      });
    },
    /* 
      点击tree菜单
    */
    handleNodeClick(data, node, vuecomponent) {
    },
    deleteProject(index, row) {
      this.$confirm('确认删除吗？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$postForm("mdc/storage/deleteOutTableById/" + row.id).then((res) => {
          this.getTableData();//刷新
          this.getPjStock();
        })
      })
    },
    addSubmit() {
      this.$refs.addOutForm.validate(valid => {
        console.log(valid)
        if(this.addForm.no == null || this.addForm.no == ""){
          return;
        }
        if(this.addForm.type == null || this.addForm.type == ""){
          return;
        }
        if(this.addForm.inTime == null || this.addForm.inTime == ""){
          return;
        }
        if (valid) {
          let list = [];
          this.addForm.checkedList.forEach(item => {
            if (item.checkNum != null && Number(item.checkNum) > 0) {
              list.push({
                storageId: item.id,
                number: item.checkNum,
              })
            }
          })
          let params = {
            no: this.addForm.no,
            type: this.addForm.type,
            applicants: this.addForm.creator,
            totalPrice: this.addForm.totalPrice,
            inTime: this.addForm.inTime,
            depart: this.addForm.depart,
            affirmant: this.addForm.affirmant,
            enterTime: this.addForm.enterTime,
            remark: this.addForm.remark,
            creator: this.addForm.creator,
            groupId: this.addForm.groupId,
            stroageItemList: list
          }
          console.log(params);
          this.$postJson('mdc/storage/addOutTable', params).then(res => {
            if (res.code = 200) {
              this.treeData.forEach(item => {
                item.checkNum = undefined;
                item.list.forEach(item2 => {
                  item2.checkNum = 0;
                })
              })
              this.getTableData();
              this.getPjStock();
              this.addFormVisible = false;
            }
          });
        }
      });



    },
    checkClick() {
      let res = this.$refs.tree.getCheckedNodes();
      let checkedList = [];
      let totalPrice = 0;
      res.forEach((item, index) => {
        //去掉父节点  父节点的 item.label.show为false
        if (item.list == null) {
          checkedList.push(item);
          totalPrice = totalPrice + (item.checkNum || 0) * item.shopPrice
        }
      });
      this.addForm.checkedList = checkedList;
      this.addForm.totalPrice = totalPrice;
    },
    handleAdd() {
      this.addForm = {
        no: "",
        type: "",
        affirmant: "",
        inTime: "",
        creator: "",
        enterTime: "",
        depart: "",
        totalPrice: "",
        remark: "",
        checkedList: [],
        groupId: this.groupId
      };
      this.treeData.forEach(item => {
        item.checkNum = undefined;
        item.list.forEach(item2 => {
          item2.checkNum = 0;
        })
      })
      this.addFormVisible = true;
      this.$nextTick(() => {
        console.log("setCheckedKeys null")
        this.$refs.tree.setCheckedKeys([]);
      });
    },
    getPjStock() {
      let params = {
        groupId: this.groupId,
        pageSize: 999,
        pageNum: 1
      };
      this.$postJson('mdc/storage/queryStockWithPage', params).then(res => {
        if (res.code == 200) {
          let dataArr = []
          let arr = res.result.list;
          arr.map(oneDim => {
            oneDim.label = oneDim.name;
            oneDim.checkNum = 0;
            if (dataArr.length == 0) {
              dataArr.push({
                label: oneDim.type,
                id: oneDim.id,
                list: [oneDim],
                type: oneDim.type
              })
            } else {
              let res = dataArr.some(item => { // 判断相同，有就添加到当前项
                if (item.type == oneDim.type) {
                  item.list.push(oneDim)
                  return true
                }
              })
              if (!res) { // 如果没找相同添加一个新对象
                dataArr.push({
                  label: oneDim.type,
                  id: oneDim.id,
                  list: [oneDim],
                  type: oneDim.type
                })
              }
            }
          })
          console.log(dataArr);
          this.treeData = dataArr;
        }
      })
    },
  },
  mounted() {
    this.getTableData();
    this.getPjStock();
  },
  created() {
    this.groupId = sessionStorage.getItem("groupId");
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}

.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}

.eltable ::v-deep .el-table__expanded-cell {
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 70px;
  padding-right: 10px;
  background: #f2f2f2;
}

.eltable ::v-deep .el-form-item {
  margin-bottom: 0px;
}

.eltable ::v-deep .el-form-item__content {
  line-height: 40px;
}

.eltable ::v-deep .el-form-item__content {
  font-size: 13px;
}

.eltable ::v-deep .el-form-item__label {
  font-size: 13px;
}

.tree-row ::v-deep .el-input-number--mini {
  line-height: 20px;
}

.tree-row ::v-deep .el-input--mini .el-input__inner {
  height: 22px;
}

.custom-tree-node-1 {
  width: 180px;
  display: inline-block;
  padding-left: 10px;
}

.custom-tree-node-2 {
  min-width: 60px;
  display: inline-block;
}

.dialog_form ::v-deep .el-form-item {
  margin-bottom: 6px;
}

.big-input {
  width: 587px;
}

.dialog_form ::v-deep .el-input--small .el-input__inner {
  max-width: 180px;
}

.rowtab ::v-deep .el-form-item__label {
  line-height: 40px;
}

.dialog_form ::v-deep .el-date-editor {
  max-width: 180px;
}
</style>